module.exports = __webpack_public_path__ + "static/img/RS@3x.d206d094.jpg";